module.exports = __webpack_public_path__ + "img/icon_cp@2x.8fdb85ba.png";